// LOCAL URL
// const API_URL = "http://192.168.175.49:9005/";

// STAGING URL
// const API_URL = "https://staging.travelyatra.com/";

// PRODUCTION URL
const API_URL = "https://api.travelyatra.com/";

export const AUTH_URL = `${API_URL}api/unsecure/v1/auth/`;
export const BASE_URL = `${API_URL}api/`;

export const PAGINATION_ITEM_LIMIT = 40;
